import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Col, Row, Button } from "antd";

import { SvgInfoFill } from "@/assets/icons";
import { useEffect, useState, useRef } from "react";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
const ANIMATION_TIME = 1000;
const parseNumberToArray = (num = 0) => {
	let values = [];
	for (let index = 0; index < num; index++) {
		values.push(index);
	}
	return values;
};

const isOverflown = (element) => {
	if (!element) return false;
	return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

export function AircraftComfort({
	amenities = {},
	luggages = {},
	seatMaps = [],
	description = "",
	showComfort = false,
}) {
	const [ref, { isVisible }] = useTrackVisibility();
	const [imageSeatMap, setImageSeatMap] = useState({
		currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
		loaded: false,
		nextSeatmap: null,
	});
	const amenitiesRef = useRef(null);

	useEffect(() => {
		if (isVisible && seatMaps?.length > 0) {
			setTimeout(() => {
				setImageSeatMap((prev) => {
					return {
						...prev,
						loaded: true,
					};
				});
			}, ANIMATION_TIME);
		}
	}, [isVisible]);

	useEffect(() => {
		if (seatMaps?.length > 0) {
			setImageSeatMap((prev) => {
				return {
					...prev,
					currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
					loaded: false,
					nextSeatmap: null,
				};
			});
		}
	}, [seatMaps]);

	return (
		<Container ref={ref} style={{ opacity: isVisible ? 1 : 0 }}>
			<Row gutter={[30, 20]} style={{ height: "100% " }}>
				<Col xl={9} lg={9} md={14} sm={16} xs={18}>
					<WrapperContent>
						<RATypography variant="h3">Comfort</RATypography>
					</WrapperContent>
					<RATypography variant="body3" top="20px" color="#595959">
						{description}
					</RATypography>
					<WrapperComfort>
						<Row gutter={[20, 20]}>
							<Col span={24} className={isVisible ? "animation_backInRight" : ""}>
								<LuggageList type="small_bags" quantity={luggages?.small_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.1s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="medium_bags" quantity={luggages?.medium_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.2s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="large_bags" quantity={luggages?.large_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.3s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="golf_clubs" quantity={luggages?.golf_clubs || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.4s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="skis" quantity={luggages?.skis || 0} />
							</Col>
						</Row>
					</WrapperComfort>
					<RATypography variant="sub-heading3" color="#222222" top={20} bottom={12}>
						Alternate Configurations
					</RATypography>
					<Row gutter={[20, 12]}>
						{seatMaps?.length > 0
							? seatMaps?.map((item, index) => (
									<Col key={`configuration=${index}`}>
										<WrapperConfiguration
											disabled={!imageSeatMap?.loaded}
											active={item?._id === imageSeatMap?.currentSeatmap?._id ? "true" : "false"}
											onClick={() => {
												if (imageSeatMap?.currentSeatmap?._id !== item?._id) {
													setImageSeatMap((prev) => {
														return {
															...prev,
															nextSeatmap: item,
															loaded: false,
														};
													});
													setTimeout(() => {
														setImageSeatMap((prev) => {
															return {
																...prev,
																currentSeatmap: prev.nextSeatmap,
																nextSeatmap: null,
																loaded: true,
															};
														});
													}, ANIMATION_TIME);
													// setImageSeatMap(item)
												}
											}}
										>
											<RATypography variant="sub-heading4" color="#222222">
												{` Configuration ${index + 1}`}
											</RATypography>
										</WrapperConfiguration>
									</Col>
								))
							: null}
					</Row>
				</Col>
				<Col
					xl={6}
					lg={6}
					md={10}
					sm={8}
					xs={6}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						transition: "all 1s",
					}}
				>
					<ImageContainer
						triggerAnimation={
							isVisible && (imageSeatMap?.nextSeatmap && !imageSeatMap?.loaded ? "moveOut" : "moveIn")
						}
					>
						<RAImage
							url={imageSeatMap?.currentSeatmap?.url}
							width={"100%"}
							height="100%"
							objectFit="contain"
						/>
					</ImageContainer>
				</Col>
				<Col xl={9} lg={9} md={24} sm={24} xs={24}>
					<RATypography variant="sub-heading3" color="#222222" bottom={20}>
						Feature Amenities
					</RATypography>
					<Row
						ref={amenitiesRef}
						id={isOverflown(amenitiesRef?.current) ? "snap-disabled" : ""}
						gutter={[20, 16]}
						style={{
							maxHeight: "80vh",
							overflowY: "scroll",
							overflowX: "hidden",
						}}
					>
						{amenities?.length > 0
							? amenities?.map((item, index) => (
									<Col
										style={{
											animationDuration: `${1 + index * 0.1}s`,
										}}
										className={isVisible ? "animation_backInLeft" : ""}
										span={24}
										key={`amenities-${index}`}
									>
										<AmenitiesItem>
											<RAImage url={item?.image?.url} width={24} height={24} sizes="24px" />
											<RATypography variant="body2" color="#222222">
												{item?.name || ""}
											</RATypography>
										</AmenitiesItem>
									</Col>
								))
							: null}
						<Col
							span={24}
							style={{
								display: "flex",
								gap: 16,
								alignItems: "center",
							}}
						>
							<SvgInfoFill color="#595959" />
							<RATypography variant="body3" color="#222222">
								Amenities may vary on specific aircraft
							</RATypography>
						</Col>
					</Row>
				</Col>
			</Row>
		</Container>
	);
}

export function AircraftComfortMobile({
	amenities = {},
	luggages = {},
	seatMaps = [],
	description = "",
	showComfort = false,
}) {
	const [ref, { isVisible }] = useTrackVisibility();
	const [imageSeatMap, setImageSeatMap] = useState(seatMaps?.length > 0 ? seatMaps?.[0] : {});
	return (
		<Container style={{ opacity: isVisible ? 1 : 0 }}>
			<Row gutter={[30, 20]} style={{ height: "100% " }}>
				<Col span={24}>
					<WrapperContent>
						<RATypography variant="h3">Comfort</RATypography>
					</WrapperContent>
					<RATypography variant="body3" top="20px" color="#595959">
						{description}
					</RATypography>
					<WrapperComfort ref={ref}>
						<Row gutter={[20, 20]}>
							<Col span={24} className={isVisible ? "animation_backInRight" : ""}>
								<LuggageList type="small_bags" quantity={luggages?.small_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.1s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="medium_bags" quantity={luggages?.medium_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.2s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="large_bags" quantity={luggages?.large_bags || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.3s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="golf_clubs" quantity={luggages?.golf_clubs || 0} />
							</Col>
							<Col
								span={24}
								style={{ animationDuration: "1.4s" }}
								className={isVisible ? "animation_backInRight" : ""}
							>
								<LuggageList type="skis" quantity={luggages?.skis || 0} />
							</Col>
						</Row>
					</WrapperComfort>
				</Col>
			</Row>
		</Container>
	);
}

export function AircraftConfigurationMobile({ amenities = {}, luggages = {}, seatMaps = [], showComfort = false }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const [imageSeatMap, setImageSeatMap] = useState({
		currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
		loaded: false,
		nextSeatmap: null,
	});

	useEffect(() => {
		if (isVisible && seatMaps?.length > 0) {
			setTimeout(() => {
				setImageSeatMap((prev) => {
					return {
						...prev,
						loaded: true,
					};
				});
			}, ANIMATION_TIME);
		}
	}, [isVisible]);

	useEffect(() => {
		if (seatMaps?.length > 0) {
			setImageSeatMap((prev) => {
				return {
					...prev,
					currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
					loaded: false,
					nextSeatmap: null,
				};
			});
		}
	}, [seatMaps]);
	return (
		<Container
			ref={ref}
			style={{
				display: "flex",
				flexDirection: "column",
				opacity: isVisible ? 1 : 0,
			}}
		>
			<Row
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					transition: "all 1s",
					height: "100%",
					padding: 20,
					flexGrow: 1,
					minHeight: "60vh",
				}}
			>
				<ImageContainer
					triggerAnimation={
						isVisible && (imageSeatMap?.nextSeatmap && !imageSeatMap?.loaded ? "moveOut" : "moveIn")
					}
				>
					<RAImage url={imageSeatMap?.currentSeatmap?.url} width={"100%"} height="100%" objectFit="contain" />
				</ImageContainer>
			</Row>
			<Row>
				<RATypography variant="sub-heading3" color="#222222" top={20} bottom={12}>
					Alternate Configurations
				</RATypography>
			</Row>
			<Row gutter={[20, 12]} style={{ paddingBottom: 28 }}>
				{seatMaps?.length > 0
					? seatMaps?.map((item, index) => (
							<Col key={`configuration=${index}`}>
								<WrapperConfiguration
									disabled={!imageSeatMap?.loaded}
									active={item?._id === imageSeatMap?.currentSeatmap?._id ? "true" : "false"}
									onClick={() => {
										if (imageSeatMap?.currentSeatmap?._id !== item?._id) {
											setImageSeatMap((prev) => {
												return {
													...prev,
													nextSeatmap: item,
													loaded: false,
												};
											});
											setTimeout(() => {
												setImageSeatMap((prev) => {
													return {
														...prev,
														currentSeatmap: prev.nextSeatmap,
														nextSeatmap: null,
														loaded: true,
													};
												});
											}, ANIMATION_TIME);
										}
									}}
								>
									<RATypography variant="sub-heading4" color="#222222">
										{` Configuration ${index + 1}`}
									</RATypography>
								</WrapperConfiguration>
							</Col>
						))
					: null}
			</Row>
		</Container>
	);
}

export function AircraftConfigurationTablet({ amenities = {}, luggages = {}, seatMaps = [], showComfort = false }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const amenitiesRef = useRef(null);
	const [imageSeatMap, setImageSeatMap] = useState({
		currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
		loaded: false,
		nextSeatmap: null,
	});

	useEffect(() => {
		if (isVisible && seatMaps?.length > 0) {
			setTimeout(() => {
				setImageSeatMap((prev) => {
					return {
						...prev,
						loaded: true,
					};
				});
			}, ANIMATION_TIME);
		}
	}, [isVisible]);

	useEffect(() => {
		if (seatMaps?.length > 0) {
			setImageSeatMap((prev) => {
				return {
					...prev,
					currentSeatmap: seatMaps?.length > 0 ? seatMaps?.[0] : {},
					loaded: false,
					nextSeatmap: null,
				};
			});
		}
	}, [seatMaps]);

	return (
		<Container
			ref={ref}
			style={{
				display: "flex",
				flexDirection: "column",
				opacity: isVisible ? 1 : 0,
			}}
		>
			<Row align="middle" gutter={80}>
				<Col span={12}>
					<Row
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							transition: "all 1s",
							height: "100%",
							padding: 20,
							flexGrow: 1,
						}}
					>
						<div
							style={{
								width: "100%",
								height: "60vh",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								position: "relative",
								transition: "all 1s",
							}}
						>
							<ImageContainer
								triggerAnimation={
									isVisible &&
									(imageSeatMap?.nextSeatmap && !imageSeatMap?.loaded ? "moveOut" : "moveIn")
								}
							>
								<RAImage
									url={imageSeatMap?.currentSeatmap?.url}
									width={"100%"}
									height="100%"
									objectFit="contain"
								/>
							</ImageContainer>
						</div>
					</Row>
					<Row>
						<RATypography variant="sub-heading3" color="#222222" top={20} bottom={12}>
							Alternate Configurations
						</RATypography>
					</Row>
					<Row gutter={[20, 12]}>
						{seatMaps?.length > 0
							? seatMaps?.map((item, index) => (
									<Col key={`configuration=${index}`}>
										<WrapperConfiguration
											disabled={!imageSeatMap?.loaded}
											active={item?._id === imageSeatMap?.currentSeatmap?._id ? "true" : "false"}
											onClick={() => {
												if (imageSeatMap?.currentSeatmap?._id !== item?._id) {
													setImageSeatMap((prev) => {
														return {
															...prev,
															nextSeatmap: item,
															loaded: false,
														};
													});
													setTimeout(() => {
														setImageSeatMap((prev) => {
															return {
																...prev,
																currentSeatmap: prev.nextSeatmap,
																nextSeatmap: null,
																loaded: true,
															};
														});
													}, ANIMATION_TIME);
													// setImageSeatMap(item)
												}
											}}
										>
											<RATypography variant="sub-heading4" color="#222222">
												{` Configuration ${index + 1}`}
											</RATypography>
										</WrapperConfiguration>
									</Col>
								))
							: null}
					</Row>
				</Col>
				<Col span={12}>
					<Row>
						<RATypography variant="sub-heading3" color="#222222" bottom={20}>
							Feature Amenities
						</RATypography>
					</Row>
					<Row
						gutter={[20, 16]}
						style={{
							maxHeight: "80vh",
							overflowY: "scroll",
							overflowX: "hidden",
						}}
						id={isOverflown(amenitiesRef?.current) ? "snap-disabled" : ""}
						ref={amenitiesRef}
					>
						{amenities?.length > 0
							? amenities?.map((item, index) => (
									<Col
										span={24}
										key={`amenities-${index}`}
										style={{
											animationDuration: `${1 + index * 0.1}s`,
										}}
										className={isVisible ? "animation_backInLeft" : ""}
									>
										<AmenitiesItem>
											<RAImage url={item?.image?.url} width={24} height={24} sizes="24px" />
											<RATypography variant="body2" color="#222222">
												{item?.name || ""}
											</RATypography>
										</AmenitiesItem>
									</Col>
								))
							: null}
					</Row>
					<Row gutter={16} align="middle" style={{ paddingTop: 24 }}>
						<Col>
							<SvgInfoFill color="#595959" />
						</Col>
						<Col>
							<RATypography variant="body3" color="#222222">
								Amenities may vary on specific aircraft
							</RATypography>
						</Col>
					</Row>
				</Col>
			</Row>
		</Container>
	);
}

export function AircraftAmenitiesMobile({ amenities = {}, luggages = {}, seatMaps = [], showComfort = false }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const amenitiesRef = useRef(null);
	return (
		<Container ref={ref} style={{ opacity: isVisible ? 1 : 0 }}>
			<Row>
				<RATypography variant="sub-heading3" color="#222222" bottom={20}>
					Feature Amenities
				</RATypography>
			</Row>
			<Row
				gutter={[20, 16]}
				style={{
					maxHeight: "80vh",
					overflowY: "scroll",
					overflowX: "scroll",
				}}
				id={isOverflown(amenitiesRef?.current) ? "snap-disabled" : ""}
				ref={amenitiesRef}
			>
				{amenities?.length > 0
					? amenities?.map((item, index) => (
							<Col
								span={24}
								key={`amenities-${index}`}
								style={{
									animationDuration: `${1 + index * 0.1}s`,
								}}
								className={isVisible ? "animation_backInLeft" : ""}
							>
								<AmenitiesItem>
									<RAImage url={item?.image?.url} width={24} height={24} sizes="24px" />
									<RATypography variant="body2" color="#222222">
										{item?.name || ""}
									</RATypography>
								</AmenitiesItem>
							</Col>
						))
					: null}
			</Row>
			<Row gutter={16} align="middle" style={{ paddingTop: 24 }}>
				<Col>
					<SvgInfoFill color="#595959" />
				</Col>
				<Col>
					<RATypography variant="body3" color="#222222">
						Amenities may vary on specific aircraft
					</RATypography>
				</Col>
			</Row>
		</Container>
	);
}

const LuggageList = ({ type, quantity = 0 }) => {
	const parentRef = useRef();
	const itemsRef = useRef([]);
	const [numberOfQuantity, setNumberOfQuantity] = useState({
		quantity: 1,
		redundant: 0,
	});
	useEffect(() => {
		if (parentRef?.current && quantity >= 1) {
			itemsRef.current = itemsRef.current.slice(0, quantity);
			const parentWidth = parentRef?.current?.offsetWidth;
			const itemWidth = itemsRef?.current?.[0]?.offsetWidth;
			const gap = 20;
			const totalWidth = itemWidth * quantity + gap * (quantity - 1);
			if (totalWidth > parentWidth) {
				const numberOfQuantity = Math.floor(parentWidth / (itemWidth + gap));
				if (numberOfQuantity * (itemWidth + gap) + 35 > parentWidth) {
					setNumberOfQuantity({
						quantity: numberOfQuantity - 1,
						redundant: quantity - numberOfQuantity + 1,
					});
				} else {
					setNumberOfQuantity({
						quantity: numberOfQuantity,
						redundant: quantity - numberOfQuantity,
					});
				}
			} else {
				setNumberOfQuantity({
					quantity: quantity,
					redundant: 0,
				});
			}
		}
	}, [quantity]);

	var icon = "",
		height = 48;
	switch (type) {
		case "small_bags":
			icon = PATH_PUBLIC_IMAGES.icon_aircraft_detail_backpack;
			height = 32;
			break;
		case "medium_bags":
			icon = PATH_PUBLIC_IMAGES.icon_aircraft_detail_roller_bag;
			height = 38;
			break;
		case "large_bags":
			icon = PATH_PUBLIC_IMAGES.icon_aircraft_detail_roller_bag;
			break;
		case "golf_clubs":
			icon = PATH_PUBLIC_IMAGES.icon_aircraft_detail_golf;
			break;
		case "skis":
			icon = PATH_PUBLIC_IMAGES.icon_aircraft_detail_skiing;
			break;
		default:
			break;
	}
	return (
		<WrapperIcons ref={parentRef}>
			{quantity >= 1 && (
				<>
					{parseNumberToArray(numberOfQuantity.quantity).map((item, index) => (
						<img
							ref={(el) => (itemsRef.current[index] = el)}
							src={icon}
							key={item.toString()}
							style={{
								height: height,
							}}
						/>
					))}
					{numberOfQuantity.redundant > 0 ? <ExtendedItem number={numberOfQuantity.redundant} /> : null}
				</>
			)}
		</WrapperIcons>
	);
};

const ExtendedItem = ({ number = 0 }) => {
	return (
		<div
			style={{
				borderRadius: 40,
				background: "#F3F2F2",
				padding: "6px 10px",
			}}
		>
			<RATypography variant="heading4" color="#595959">
				{`+${number}`}
			</RATypography>
		</div>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;

	.animation_backInRight {
		animation: backToRight 1s forwards;
	}

	.animation_backInLeft {
		animation: backToLeft 1s forwards;
	}

	@keyframes backToRight {
		0% {
			transform: translateX(-2000px);
		}
		100% {
			transform: translateX(0px);
		}
	}

	@keyframes backToLeft {
		0% {
			transform: translateX(2000px);
		}
		100% {
			transform: translateX(0px);
		}
	}
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const WrapperComfort = styled.div`
	padding: 24px;
	width: 100%;
	min-height: 270px;
	border: 1px solid #e9e8e8;
	border-radius: 10px;
	margin-top: 20px;
`;
const WrapperIcons = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
	overflow-x: scroll;
`;
const WrapperConfiguration = styled(Button)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 10px 12px;
	gap: 16px;
	min-width: 128px;
	height: 42px;
	background: #ffffff;
	border: 1px solid #e9e8e8;
	border-radius: 8px;
	cursor: pointer;
	:hover {
		border: 1px solid #ffb11a;
	}
	${({ active }) =>
		active === "true" &&
		`
        border: 1px solid #ffb11a
    `};
`;
const AmenitiesItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 16px;
	gap: 16px;
	/* min-width: 343px; */
	height: 56px;
	background: #ffffff;
	box-shadow: 0px 4px 10px rgba(148, 148, 148, 0.08);
	border-radius: 8px;
`;

const ImageContainer = styled.div`
	width: 100%;
	height: 100%;
	padding: 0 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	animation: ${(props) => props.triggerAnimation} 1s forwards;
	z-index: 50;
	@keyframes moveIn {
		from {
			top: 150%;
		}
		to {
			top: 0;
		}
	}
	@keyframes moveOut {
		from {
			top: 0;
		}
		to {
			top: -150%;
		}
	}
`;
